import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	leftAlignmentLabel: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2.left',
		defaultMessage: 'Left',
		description:
			'A visible text label for the left alignment option of the link cards config panel',
	},
	centerAlignmentLabel: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2.center',
		defaultMessage: 'Center',
		description:
			'A visible text label for the center alignment option of the link cards config panel',
	},
	rightAlignmentLabel: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2.right',
		defaultMessage: 'Right',
		description:
			'A visible text label for the right alignment option of the link cards config panel',
	},
	alignmentLabel: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2',
		defaultMessage: 'Alignment',
		description: 'A visible text label for the alignment field of the link cards config panel',
	},
});
